/**
 * Shop drawings API calls: /api/shop-drawings, falling back to the legacy /api/shop_drawings prefix when the route
 * itself is missing (a 404 without a detail, or FastAPI's plain "Not Found"). A 404 that names something
 * ("Shop drawing not found") is a real answer and is not retried. Shared by the page and its wave 3 panels.
 */
import api from '@/lib/api';

const SHOP_DRAWINGS_API = '/shop-drawings';
const SHOP_DRAWINGS_API_FALLBACK = '/shop_drawings';

const routeMissing = (err) => {
  if (err?.response?.status !== 404) return false;
  const detail = err.response?.data?.detail;
  return !detail || (typeof detail === 'string' && /^not found$/i.test(detail.trim()));
};

export async function sdRequest(method, path = '', data, config) {
  try {
    return await api.request({ method, url: `${SHOP_DRAWINGS_API}${path}`, data, ...config });
  } catch (err) {
    if (!routeMissing(err)) throw err;
    return api.request({ method, url: `${SHOP_DRAWINGS_API_FALLBACK}${path}`, data, ...config });
  }
}

export default sdRequest;
